import { appendQsParams, get } from 'lib/request';

export const getAliasInfoList = async ({ aliasIds }, opts) =>
  get(appendQsParams('/alias', { alias_id: aliasIds }), opts);

export const getAliasRelatedOffersList = async ({ aliasId, page }, opts) =>
  get(
    `/alias/${aliasId}/offers/related${
      ![undefined, null].includes(page) ? `?page=${page}` : ''
    }`,
    opts
  );

export const getAliasReviewsList = ({ after, aliasId, limit }, opts) =>
  get(appendQsParams(`/v4/aliases/${aliasId}/reviews`, { after, limit }), opts);

export const getUserAliasReviewsRatings = ({ aliasId }, opts) =>
  get(`/v4/aliases/${aliasId}/review-ratings`, opts);
